module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdBAMAAACkvXo8AAAAHlBMVEXo5ujo5+jp5+nl4+Tl4+Tj4eLk4uP4+Pj6+vr///8ITo/8AAAABXRSTlOcnZ/8/RT9KgQAAAAoSURBVBjTY1AJRQLBAgzuM5HAdAeGSGT+zIBR/gDzM9DiRwQ5/kIYAEjs7Fu3buQOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/checkbox.png
// module id = 253
// module chunks = 0